import React from 'react';
import { Link } from '@ambiguous/link';
import Image from '@assets/tsx/image';
export default function CardRounded({ title, url__props, url, image }) {
    return (React.createElement(Link, { href: url, blank: !!(url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? '_blank' : null, className: "ltg-card-rounded" },
        React.createElement("div", { className: "ltg-card-img-wrap" },
            React.createElement(Image, { src: image === null || image === void 0 ? void 0 : image.url, alt: (image === null || image === void 0 ? void 0 : image.alt) || title, srcSet: image === null || image === void 0 ? void 0 : image.srcset, className: "ltg-card-img" })),
        React.createElement("h2", { className: "ltg-card-title" }, title)));
}
